export default "/images/4ef8b6a6f288454bfc1b6a8f70c9daf5.avif";